// removed by extract-text-webpack-plugin
module.exports = {"warnContain":"_2B3vPALYxpGVf-yB_eUhGE","message":"_2_3LZl9d1tTGGci0gVSD23","buttonContain":"_6FKwPq05NEwpfi0sg91SE","deleteButton":"_1wmOmWzD45n4Vb3FySn5Qg","cancelButton":"_3Vue5Htc6-o1KKd1L-pak0"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/DeleteWarn.css
// module id = 375
// module chunks = 0